import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PopoverController } from "ionic-angular";
import * as _ from "lodash";
import moment from "moment";
import { CompanyDataService } from "../../../providers/company-data-service/company-data-service";
import { DocManagementDataService } from "../../../providers/doc-management-data-service/doc-management-data-service";
import { OrderPopupComponent } from "../order-popup/order-popup";

const dateTimeFormat = "MM/DD/YYYY HH:mm";
const dateTimeFormat2 = "MM/DD/YYYY";

@Component({
  selector: "order-item",
  templateUrl: "order-item.html",
})
export class OrderItemComponent implements OnInit {
  objectKeys = Object.keys;

  @Input() item: any;
  @Input() config: string;
  @Input() orderTypeEnums: any = {};
  @Input() categoryOptions: any[] = [];
  @Input() roleEnums: any = [];
  @Input() diagnosisEnums: any = [];
  @Input() isAudit: boolean = false;
  @Input() reasonForGIPOptions: Object;
  @Input() symptoms: Object;
  @Input() selectAllSubOrders: boolean;
  @Output() onButtonPress: EventEmitter<any> = new EventEmitter();
  @Output() onSubOrderSelected: EventEmitter<boolean> = new EventEmitter();
  openStatus = false;
  lodash = _;

  constructor(
    public popover: PopoverController,
    private dataSvc: CompanyDataService,
    private documentSvc: DocManagementDataService
  ) {
    if (this.item && this.item["physician"]) {
      this.dataSvc.getPerson(this.item["physician"]["id"]).subscribe((data) => {
        this.item["physician"] = data;
      });
    }
  }

  ngOnInit(): void {
    switch (this.config) {
      case "new":
        this.openStatus = true;
        break;
      case "open":
        break;
      case "panel":
        this.openStatus = true;
        break;
      case "panel-audit":
        this.openStatus = true;
        break;
      case "active":
        break;
      default:
        break;
    }
  }

  propertiesInOrder = [
    "categories",
    //diagnosis
    "beforeCurrent",
    "previousDiagnosis",
    "newDiagnosis",
    //level of care
    "levelOfCare",
    "levelOfCareType",
    "facility",
    //recert
    "certifyingPhysician",
    "attendingPhysician",
    //visit frequency
    "role",
    "visits",
    "visitFrequency",
    "timeInterval",
    "prnVisits",
    "reason",
    //medication/dme/treatment/supplies
    "issue",
    "symptoms",
    "name",
    "dmeType",
    "supplyType",
    "treatmentType",
    "compound",
    "ingredients",
    "doseForm",
    "route",
    "strength",
    "dosingParameters",
    "frequency",
    "dosage",
    "opioid",
    "itemStartDatetime",
    "itemDiscontinueDatetime",
    "physician",
    "dcPhysician",
    "hospicePayer",
    "administeredBy",
    "teachingsPerformed",
    //"acdApproval",
    "startDate", //for diagnosis but should be after physician
    "physicianOrder",
    "physicianOrderNotes",
  ];

  noShow = [
    "dcResourceManagementPhysician",
    "resourceManagementPhysician",
    "auditId",
    "isAudit",
    "approved",
    "orderTypeId",
    "patient",
    "startedBy",
    "standingOrder",
    "updatedBy",
    "updatedDatetime",
    "startDatetime",
    "createdDatetime",
    "startedDatetime",
    "approvedDatetime",
    "auditCreatedDatetime",
    "orderStatus",
    "type",
    "activeWetSignature",
    "description",
    "order",
    "updateDatetime",
    "gpi",
    "emergencyDrugPack",
    "administered",
    "medication",
    "medicationAdminRecords",
    "otherRole",
    "acdApproval",
    "reopenedDatetime",
    "documentId",
    "rmPhysician",
    "isSubOrderChecked",
    "verified",
    "reviewed",
    "reviewedLastUpdated_Datetime",
  ];

  getSpecialProperties(orderItem) {
    if (orderItem.reviewed == true && orderItem.reviewedBy == null) {
      orderItem.reviewedBy = {};
      orderItem.reviewedBy.username = "";
    }

    return Object.keys(orderItem)
      .filter((property) => !this.noShow.includes(property))
      .filter((property) => !this.propertiesInOrder.includes(property));
  }

  convertDate(input) {
    let date = moment
      .utc(input, "YYYYMMDDTHHmmssZZ")
      .local()
      .format(dateTimeFormat);
    if (date === "Invalid date") {
      date = "";
    }
    return date;
  }

  convertDateJustDay(input) {
    let date = moment
      .utc(input, "YYYYMMDDTHHmmssZZ")
      .local()
      .format(dateTimeFormat2);
    if (date === "Invalid date") date = "";
    return date;
  }

  getReviewedBy() {
    if (this.item["reviewedBy"]) {
      return this.item["reviewedBy"].username;
    } else {
      return "";
    }
  }
  getPhysician() {
    if (this.item["rxPhysician"]) {
      return this.item["rxPhysician"];
    } else {
      return this.item["physician"];
    }
  }

  showId(config) {
    return config !== "new" && config !== "open";
  }

  /**
   * Used in conjunction with ngClass to provide an appropriate header class for the order-item
   * Mainly used for the order history section, otherwise the class will be the default
   */
  getHeaderClassForConfig(): string {
    switch (this.config) {
      case "deleted":
        return "deleted";
      case "discontinued":
        return "discontinued";
      case "denied":
        return "denied";
      default:
        return "";
    }
  }

  deletePressed() {
    this.onButtonPress.emit({ buttonType: "delete" });
  }

  editPressed() {
    this.onButtonPress.emit({ buttonType: "edit" });
  }

  ingredientsToString(ingredArray) {
    return ingredArray.map((ingred) => ingred["display"]).join(", ");
  }

  getStringForBool(bool) {
    return bool ? "yes" : "no";
  }

  approvePressed() {
    this.onButtonPress.emit({ buttonType: "approve" });
  }

  denyPressed() {
    this.onButtonPress.emit({ buttonType: "deny" });
  }

  administerPressed() {
    //this.item.administered = true;
    this.onButtonPress.emit({ buttonType: "administer", id: this.item.id });
  }

  getOrderIdText() {
    return this.isAudit ? "origOrderIDNumber" : "orderIDNumber";
  }

  displayType(): string {
    if (this.orderTypeEnums.length > 0) {
      let typeEnum = this.orderTypeEnums.find((type) => {
        return type.value === this.item.type;
      });
      if (typeEnum) {
        return typeEnum.display;
      }
    }
    return "";
  }

  displayDiagnosisType(): string {
    if (this.diagnosisEnums.length > 0) {
      let typeEnum = this.diagnosisEnums.find((type) => {
        return type.value === this.item.diagnosisType;
      });
      if (typeEnum) {
        return typeEnum.display;
      }
    }
    return "";
  }

  displayRole(): string {
    if (this.roleEnums.length > 0) {
      let roleEnum = this.roleEnums.find((role) => {
        return role.value === this.item.role;
      });
      if (roleEnum) {
        if (roleEnum.value === "OTH") return "Other - " + this.item.otherRole;
        return roleEnum.display;
      }
    }
    return this.item.role;
  }

  getDisplayValue(options, selectOptions): string {
    let displayString = [];
    if (!_.isEmpty(this[options])) {
      _.forEach(this[options], (ele) => {
        if (_.includes(selectOptions, ele.value)) {
          displayString.push(ele.display);
        }
      });
      return _.join(displayString, ", ");
    }
    return "";
  }

  displayDiagnosis(diagnosisArray: [{}]) {
    if (!diagnosisArray) return "";
    return diagnosisArray.map((diagnosis) => {
      return " " + diagnosis["description"] + " (" + diagnosis["code"] + ")";
    });
  }

  openOptionPopup(event, item) {
    let orderStatus = this.config == "open" ? "open-suborder" : this.config;
    let orderType = this.item.type;
    let buttonPopover = this.popover.create(
      OrderPopupComponent,
      { config: { orderStatus, orderType, item } },
      { cssClass: "open-orders-popover" }
    );

    buttonPopover.onDidDismiss((data) => {
      if (data) {
        let payload = data;
        payload.id = this.item.id;
        payload.isDiscontinueOrder = this.config === "disc";
        payload.suborder = true;
        payload.orderType = this.config;
        this.onButtonPress.emit(payload);
      }
    });

    //Change Popup Location
    let ev = {
      target: {
        getBoundingClientRect: () => {
          return {
            top: event.y + 20,
            left: event.x - 75,
          };
        },
      },
    };
    //popup spawn location needs adjustment unless on iPad
    if (window.navigator.userAgent.indexOf("iPad") != -1) {
      buttonPopover.present({ ev: event });
    } else {
      buttonPopover.present({ ev: ev });
    }
  }
  getMultipleAdminister(administeredBy) {
    if (administeredBy && administeredBy["data"]) {
      let keys = Object.keys(administeredBy["data"]);
      if (_.includes(keys, "other")) {
        let index = keys.findIndex((k) => k === "other");
        keys[index] = administeredBy["data"]["other"];
      }
      administeredBy = keys.join().replace(/,/g, ", ");
    }
    return administeredBy;
  }

  viewDocument(id) {
    this.documentSvc.viewDocument(id);
  }
  isAccess() {
    let access =
      this.config == "active" &&
      (this.item.type == "LC" ||
        (this.item.type == "DG" && this.item.diagnosisType != "RL"))
        ? false
        : true;
    return access;
  }

  subOrderSelected(e) {
    this.onSubOrderSelected.emit(e.checked);
  }
}



// WEBPACK FOOTER //
// ./src/components/orders/order-item/order-item.ts